import { Phone, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

export interface CrisisInterstitialProps {
  onContinue: () => void;
}

export function CrisisInterstitial({ onContinue }: CrisisInterstitialProps) {
  return (
    <div className="min-h-screen bg-gradient-to-b from-card to-background">
      <div className="container-px mx-auto max-w-xl px-4 py-12">
        <div className="rounded-2xl border border-border bg-card p-6 text-center shadow-soft sm:p-8">
          <div className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-accent/10">
            <Heart className="h-8 w-8 text-accent" />
          </div>
          <h2 className="font-headings text-2xl font-extrabold text-primary sm:text-3xl">
            Your safety matters most.
          </h2>
          <p className="mx-auto mt-4 max-w-md text-base leading-relaxed text-muted-foreground">
            If you're having thoughts of harming yourself, please call or text
            988 (Suicide &amp; Crisis Lifeline) now, or go to your nearest
            emergency room. You can still finish this form afterward.
          </p>
          <a
            href="tel:988"
            className="mt-6 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-accent px-6 py-4 text-lg font-bold text-accent-foreground shadow-glow transition-opacity hover:opacity-90"
          >
            <Phone className="h-5 w-5" />
            Call or Text 988 Now
          </a>
          <button
            onClick={onContinue}
            className="mt-4 inline-flex items-center justify-center text-sm font-semibold text-muted-foreground underline underline-offset-2 transition-colors hover:text-primary"
          >
            I've reached out — continue
          </button>
        </div>
      </div>
    </div>
  );
}
